import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { fieldsFormatter } from '../../../../../configuration/collaborativeIndexation'

export class Default extends Component {

    static propTypes = {
        field: PropTypes.string.isRequired,
        value: PropTypes.string,
    }

    constructor(props)
    {
        super(props)

        this.formatValue = this.formatValue.bind(this)
    }

    formatValue(value)
    {
        const { field } = this.props

        if(fieldsFormatter.hasOwnProperty(field))
        {
            return fieldsFormatter[field](value)
        }

        return fieldsFormatter['default'](value)
    }

    render()
    {
        const formattedValue = this.formatValue(this.props.value)

        return (
            <span title={ formattedValue }>
                { formattedValue }
            </span>
        )
    }
}
